
import React from "react";
import "./Services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>My Services</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>Full Stack Website Development</h3>
            <ul className="service__list">
              <li>
                <BiCheck className="service__list-icon" />
                <p>As an experienced Full-Stack Web Developer, I specialize in delivering high-performance, scalable, and user-centric web solutions tailored to meet your business and personal needs. With a robust skill set in React.js, Node.js, CSS, JavaScript, and HTML, I bring end-to-end expertise to transform your vision into reality. My services combine technical proficiency, modern design principles, and a commitment to delivering seamless digital experiences.</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Custom Web Development 
   - Build responsive, dynamic, and intuitive front-end applications using React.js and JavaScript, ensuring engaging user interfaces and smooth interactions.  
   - Develop robust and scalable back-end systems with Node.js, enabling efficient server-side logic, APIs, and database integration.  
   - Craft clean, semantic, and accessible HTML structures paired with pixel-perfect CSS styling for visually stunning and responsive designs.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>End-to-End Solutions
   - Design and implement full-stack applications, from concept to deployment, ensuring seamless integration between front-end and back-end components.  
   - Leverage RESTful APIs, third-party integrations, and modern frameworks to create secure and efficient web applications.  
   - Optimize performance, scalability, and security to deliver fast, reliable, and maintainable solutions.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>UI/UX Design Implementation
   - Translate wireframes and design mockups into fully functional, responsive interfaces with a focus on usability and aesthetics.  
   - Utilize **CSS** frameworks (e.g., Tailwind CSS, Bootstrap) and custom styling to create visually cohesive and mobile-friendly designs.  
   - Ensure cross-browser compatibility and adherence to web accessibility standards (WCAG).</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Maintenance & Optimization
   - Provide ongoing support, bug fixes, and performance optimization for existing web applications.  
   - Implement SEO best practices and optimize load times to improve user engagement and search engine rankings.  
   - Conduct code reviews and refactoring to ensure clean, maintainable, and future-proof codebases.</p>
              </li>
            </ul>
          </div>
        </article>

        {/* END OF WEB DEVELOPMENT */}

        <article className="service">
          <div className="service__head">
            <h3>Computer Analyst</h3>
            <ul className="service__list">
              <li>
                <BiCheck className="service__list-icon" />
                <p>As an accomplished Computer Analyst with extensive experience in system analysis, data management, and IT solutions, I specialize in optimizing technology ecosystems to drive business efficiency and innovation. Leveraging expertise in system diagnostics, process optimization, and data-driven decision-making, I deliver tailored solutions that enhance operational performance and align with strategic objectives. My services combine technical proficiency, analytical precision, and a commitment to delivering measurable results.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>System Analysis & Optimization
   - Conduct comprehensive assessments of IT systems, identifying inefficiencies, bottlenecks, and opportunities for improvement.  
   - Design and implement optimized workflows, system architectures, and processes to enhance performance, scalability, and reliability.  
   - Provide actionable recommendations to align technology infrastructure with business goals.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Data Analysis & Insights
   - Analyze complex datasets to uncover trends, patterns, and actionable insights that inform strategic decision-making.  
   - Develop and implement data models, dashboards, and reporting tools to support business intelligence and performance tracking.  
   - Ensure data integrity, security, and compliance with industry standards and regulations.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Troubleshooting & Problem Resolution
   - Diagnose and resolve complex technical issues, including system failures, software bugs, and performance degradation.  
   - Implement proactive monitoring and maintenance strategies to minimize downtime and ensure slystem reliability.  
   - Offer expert support for hardware, software, and network-related challenges.

</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Process Automation & Efficiency**  
   - Identify opportunities for automation to streamline repetitive tasks and improve operational efficiency.  
   - Develop and deploy automation scripts, workflows, and tools to reduce manual effort and enhance productivity.  
   - Optimize business processes through technology-driven solutions, improving speed and accuracy.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Consulting & Training**  
   - Provide strategic IT consulting to align technology initiatives with organizational goals and industry best practices.  
   - Deliver training and documentation to empower teams with the knowledge and tools needed to leverage systems effectively.  
   - Collaborate with stakeholders to ensure successful adoption of new technologies and processes.
</p>
              </li>
            </ul>
          </div>
        </article>

        {/* END OF COMPUTER ANALYST */}

        <article className="service">
          <div className="service__head">
            <h3>Content Creation</h3>
            <ul className="service__list">
              <li>
                <BiCheck className="service__list-icon" />
                <p>I bring a unique blend of technical expertise and creative storytelling to deliver dynamic web solutions and engaging tech-focused content. I help businesses and individuals establish a strong online presence and connect with their audiences. My services are designed to drive innovation, engagement, and measurable results through cutting-edge development and impactful communication.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Full-Stack Solutions
   - Deliver end-to-end web development, from ideation to deployment, integrating front-end and back-end components for seamless functionality.  
   - Implement RESTful APIs, third-party integrations, and modern frameworks to build secure, scalable, and efficient applications.  
   - Optimize websites for performance, SEO, and user experience to drive engagement and conversions.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Tech Content Creation
   - Produce high-quality, engaging content, including blog posts, tutorials, case studies, and technical guides, tailored to tech-savvy audiences.  
   - Create clear, accessible explanations of complex technical concepts, bridging the gap between developers, businesses, and end-users.  
   - Develop content strategies to boost brand visibility, educate audiences, and establish thought leadership in the tech space.</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>With extensive experience as a Website Developer and Tech Content Creator, I offer a rare combination of technical precision and creative expertise. My ability to build robust, user-centric websites and craft compelling tech content enables me to deliver solutions that not only perform flawlessly but also resonate with audiences. Whether you need a dynamic web application, an engaging tech blog, or a cohesive digital strategy, I’m dedicated to delivering results that elevate your brand and drive success.</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Content-Driven Web Solutions
   - Integrate dynamic content management systems (CMS) to empower clients to update and manage their websites effortlessly.  
   - Combine development and content expertise to create blogs, portfolios, or e-learning platforms that engage and inform users.  
   - Optimize content for SEO to enhance discoverability and drive organic traffic.
</p>
              </li>
            </ul>
          </div>
        </article>

{/* END OF CONTENT CREATION */}



<article className="service">
          <div className="service__head">
            <h3>Carpentry And Furnishing Designer</h3>
            <ul className="service__list">
              <li>
                <BiCheck className="service__list-icon" />
                <p>I'm also a professional Carpenter and Furniture Designer, I specialize in crafting high-quality, bespoke woodwork and furniture that blend functionality, artistry, and durability. With years of experience in precision carpentry and innovative design, I create custom pieces and structural solutions that elevate spaces and meet the unique needs of my clients. My services combine expert craftsmanship, creative design, and a commitment to delivering timeless, sustainable results.



</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Custom Furniture Design & Fabrication**  
   - Design and craft bespoke furniture, including tables, chairs, cabinets, shelving, and more, tailored to your aesthetic and functional requirements.  
   - Create unique, handcrafted pieces that reflect your style, from modern minimalist to rustic or classical designs.  
   - Utilize premium materials, such as hardwoods, reclaimed wood, or sustainable alternatives, to ensure durability and beauty.

</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Furniture Restoration & Refinishing
   - Restore antique or worn furniture to its original glory, preserving its character while enhancing durability and appearance.  
   - Provide refinishing services, including staining, painting, and polishing, to refresh and modernize existing pieces.  
   - Repair structural damage, ensuring restored furniture is both functional and visually appealing.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Space Planning & Custom Solutions 
   - Collaborate with clients to design furniture and woodwork that optimizes space, enhances functionality, and complements interior design themes.  
   - Offer tailored solutions for small spaces, multi-functional furniture, or specialized commercial installations.  
   - Provide 3D renderings or sketches to visualize designs before fabrication, ensuring alignment with client expectations.

</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Sustainable & Eco-Friendly Practices  
   - Source sustainable, high-quality materials and employ environmentally conscious techniques to minimize waste and environmental impact.  
   - Incorporate reclaimed or responsibly sourced wood to create unique, eco-friendly pieces with character and story.  
   - Advise clients on sustainable design choices that balance aesthetics, functionality, and environmental responsibility.
</p>
              </li>

              <li>
                <BiCheck className="service__list-icon" />
                <p>Consulting & Project Management
   - Offer expert consultation on material selection, design concepts, and project feasibility to bring your vision to life.  
   - Manage projects from concept to completion, coordinating with architects, contractors, and designers to ensure timely and flawless execution.  
   - Provide maintenance advice to preserve the longevity and beauty of custom woodwork and furnitures. 
</p>
              </li>
            </ul>
          </div>
        </article>

        {/* END OF CARPENTRY AND FURNITURE */}



      </div>
    </section>
  );
};
export default Services;
